import { RadioGroup } from '@material-ui/core';
import { useAppDispatch, useAppSelector } from '../../../../../../App/redux/store';
import { adActions, getAdState } from '../../../../adSlice';
import styles from './similarPlotResult.module.scss';
import SimilarPlotResultCard from './SimilarPlotResultCard';

interface ISimilarPlotsResultContainerProps {
  adCity: ICity;
}
function SimilarPlotsResultContainer({ adCity }: ISimilarPlotsResultContainerProps) {
  const { similarAdPlots, adGeoAddress, highlightedPlotId } =
    useAppSelector(getAdState);
  const dispatch = useAppDispatch();
  if (!similarAdPlots.result) return null;

  const handleRadioClick = (address: string) => {
    dispatch(adActions.adGeoAddressToggle(address));
  };

  return (
    <section className={styles.similarPlotResultContainer}>
      <h3>{`Bien(s) identifié(s) possédant les mêmes carastéristiques à ${adCity?.name}`}</h3>

      <div className={styles.cardContainer}>
        {similarAdPlots.result.length === 0 ? (
          <div className={styles.emptyState}>
            <p>
              Aucune annonce trouvée correspondant aux critères de surface spécifiés.
            </p>
          </div>
        ) : (
          <RadioGroup value={adGeoAddress}>
            {similarAdPlots.result.map((m, i) => (
              <SimilarPlotResultCard
                key={m.fullPlotId}
                adPlot={m}
                index={i}
                isHighlighted={highlightedPlotId === m.fullPlotId}
                onRadioClick={handleRadioClick}
              />
            ))}
          </RadioGroup>
        )}
      </div>
    </section>
  );
}

export default SimilarPlotsResultContainer;
